export const GET_FORKS_REQUEST = "GET_FORKS_REQUEST";

export const GET_FORKS_SUCCESS = "GET_FORKS_SUCCESS";

export const GET_FORKS_ERROR = "GET_FORKS_ERROR";

export const API_REQUEST = "Api request";

export const BASE_URL = "https://api.github.com/repos/";
